var render = function (_h,_vm) {var _c=_vm._c;return _c('span',_vm._b({staticClass:"icon has-text-info"},'span',_vm.data.attrs,false),[_c('i',{staticClass:"fas fa-dolly"})])}
var staticRenderFns = []

export { render, staticRenderFns }